var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Support")))]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("a", { attrs: { href: "mailto:asiointituki.stea@gov.fi" } }, [
        _vm._v("asiointituki.stea@gov.fi")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }